var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white d-lg-none d-block fixed-top d-flex align-items-center justify-content-between border-bottom shadow-sm",attrs:{"id":"mobile-header"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }